import { Component, inject } from '@angular/core';
import {
  AttachmentDetailDto,
  BuildingDetailDto,
  BuildingFilterDto, EquipmentItemDto,
  MaintenanceTimerDetailDto,
  MaintenanceTimerFilterDto, MaintenanceTimerService, TenantDetailDto,
} from '@artemis-software/wr-api';
import { MaintenanceTimerState } from '@/store/maintenanceTimer/maintenanceTimer.state';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { differenceInDays } from 'date-fns';
import { toLocalDateBounds } from '@/utils/filter-range-utils';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'wr-internal-maintenance-timer-overview-page',
  styleUrls: ['./internal-maintenance-timer-overview-page.component.scss'],
  templateUrl: './internal-maintenance-timer-overview-page.component.html',
})
export class InternalMaintenanceTimerOverviewPageComponent {
  form!: FormGroup;

  private readonly router = inject(Router);
  private readonly formBuilder = inject(FormBuilder);
  private readonly maintenanceTimerService = inject(MaintenanceTimerService);

  readonly loadMaintenanceTimers = (filter: MaintenanceTimerFilterDto) => this.maintenanceTimerService.findAllDetailDtos(this.prepareFilter(filter));
  readonly getCount = (filter: MaintenanceTimerFilterDto) => this.maintenanceTimerService.getCount(this.prepareFilter(filter));

  private prepareFilter(filter: MaintenanceTimerFilterDto): MaintenanceTimerFilterDto {
    return {
      ...filter,
      selectedRange: undefined,
      ...toLocalDateBounds(filter.selectedRange),
    };
  }

  @Select(MaintenanceTimerState.filteredMaintenanceTimers)
  maintenanceTimers$!: Observable<MaintenanceTimerDetailDto[]>;

  constructor() {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
      ownerTenantId: this.formBuilder.control(''),
      creatorTenantId: this.formBuilder.control(''),
      equipmentId: this.formBuilder.control(''),
      equipment: this.formBuilder.control(undefined),
      buildingId: this.formBuilder.control(''),
      selectedRange: new FormControl(null),
      building: this.formBuilder.control(undefined),
    });

    this.form.get('equipment')?.valueChanges.subscribe((equipment: EquipmentItemDto) => {
      this.form.get('equipmentId')?.setValue(equipment?.id);
    });

    this.form.get('building')?.valueChanges.subscribe((building: BuildingDetailDto) => {
      this.form.get('buildingId')?.setValue(building?.id);
    });
  }

  navigateToMaintenanceTimer(entity: MaintenanceTimerDetailDto) {
    this.router.navigate(['buildingEquipment', entity.buildingEquipment.id]);
  }

  getIcon(attachment: AttachmentDetailDto | undefined): string {
    if (!attachment) {
      return '';
    }
    return attachment.presignedUrl ?? '';
  }

  dueDays(date: Date): number {
    const current = new Date();
    return differenceInDays(date, current);
  }

  readonly exportDueDays = (entity: MaintenanceTimerDetailDto): string =>
    String(this.dueDays(new Date(entity.nextDate)));

  protected readonly BuildingFilterDto = BuildingFilterDto;
  protected readonly TenantTypeEnum = TenantDetailDto.TypeEnum;
}
